import getFormattedSourceDetails from "@Utils/getFormattedSourceDetails";

const getAppLink = (singularUrl: string) => {
  if (!singularUrl) return "";
  try {
    const searchParam = singularUrl.split("?")?.[1];
    const newParam = new URLSearchParams(searchParam);
    newParam.delete("_p");
    if (__CLIENT__) {
      const canonicalName = window.location.pathname.split("/").pop() || "";
      const params = {
        ...(canonicalName ? { canonical_name: canonicalName } : {}),
      };
      newParam.set("_p", JSON.stringify(params));
      newParam.set(
        "_web_params",
        new URLSearchParams(getFormattedSourceDetails() || "").toString(),
      );
    }

    if (!newParam.toString()) {
      return singularUrl;
    }

    return `${singularUrl.split("?")?.[0]}?${newParam.toString()}`;
  } catch {
    return singularUrl;
  }
};

export default getAppLink;
